/* Bella K Relaunch: „Post aus Berlin.“ (bkr-newsletter). Quelle: prototypes/v3d/main.js, „newsletter“.
   Prüft E-Mail und Einwilligung im Browser wie im Prototyp; ist alles gültig, wird das Shopify-Formular
   wirklich abgeschickt (Kunde mit Tag „newsletter“). */
(function () {
  if (!window.bkr) return;
  var bkr = window.bkr;

  bkr.section('.s-newsletter', function (root) {
    var form = bkr.$('form.nl__form', root);
    if (!form) return;
    var email = bkr.$('input[type="email"]', form);
    var consent = bkr.$('input[name="consent"]', form);
    var err = bkr.$('.nl__error', form);
    var ok = bkr.$('.nl__success', root);
    form.noValidate = true; // eigene Meldungen statt Browser-Blasen (ohne JS bleibt die Browser-Prüfung)

    var onSubmit = function (ev) {
      var msg = '';
      var bad = null;
      if (!email.value || !email.checkValidity()) { msg = form.getAttribute('data-msg-email') || ''; bad = email; }
      else if (consent && !consent.checked) { msg = form.getAttribute('data-msg-consent') || ''; bad = consent; }
      email.setAttribute('aria-invalid', String(bad === email));
      if (err) { err.hidden = !msg; err.textContent = msg; }
      if (bad) { ev.preventDefault(); bad.focus(); }
    };
    form.addEventListener('submit', onSubmit);

    // nach erfolgreicher Anmeldung (Seite lädt neu) die Bestätigung vorlesen lassen
    if (ok && !ok.hidden) { try { ok.focus({ preventScroll: true }); } catch (e) { ok.focus(); } }

    return function () { form.removeEventListener('submit', onSubmit); };
  });
})();
